import * as React from "react";
const SvgSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 24, viewBox: "0 0 40 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.23738 22.7624H38.2077V1.23762H1.23738V22.7624Z", fill: "white", stroke: "black", strokeWidth: 2 }));
export default SvgSquare;
